"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { Component, createRef } from "react";
import { createPortal } from "react-dom";
import { Transition } from "react-transition-group";
import observeRect from "@reach/observe-rect";
import classNames from "classnames";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { observer } from "mobx-react";
import { action, computed, observable } from "mobx";
import getOverlayPosition from "../../../utils/getOverlayPosition";
import getPortalRoot from "../../../utils/getPortalRoot";
import forceReflow from "../../../utils/forceReflow";
import { KeyType, randomString, shouldUpdatePosition } from "../../../utils";
import { AnimationDuration } from "../../../styles/Animations";
import Panel from "../Panel/Panel";
import { handleMouseUpByBlurring } from "../../../utils/focus";
import { Layer } from "../../../utils/layers/LayerContext";
import { scrollAwayObserver } from "../../../utils/scrollAwayObserver";
export var PopoverPosition = /* @__PURE__ */function (PopoverPosition2) {
  PopoverPosition2["Top"] = "top";
  PopoverPosition2["Right"] = "right";
  PopoverPosition2["Bottom"] = "bottom";
  PopoverPosition2["Left"] = "left";
  return PopoverPosition2;
}(PopoverPosition || {});
export var PopoverTheme = /* @__PURE__ */function (PopoverTheme2) {
  PopoverTheme2["Dark"] = "dark";
  PopoverTheme2["Light"] = "light";
  return PopoverTheme2;
}(PopoverTheme || {});
export var PopoverSize = /* @__PURE__ */function (PopoverSize2) {
  PopoverSize2["Small"] = "small";
  PopoverSize2["Medium"] = "medium";
  PopoverSize2["Large"] = "large";
  PopoverSize2["Auto"] = "auto";
  return PopoverSize2;
}(PopoverSize || {});
export var PopoverAlignment = /* @__PURE__ */function (PopoverAlignment2) {
  PopoverAlignment2["Start"] = "start";
  PopoverAlignment2["Center"] = "center";
  return PopoverAlignment2;
}(PopoverAlignment || {});
var Popover = /*#__PURE__*/function (_Component) {
  _inherits(Popover, _Component);
  var _super = _createSuper(Popover);
  function Popover() {
    var _this;
    _classCallCheck(this, Popover);
    _this = _super.apply(this, arguments);
    _this.internalIsOpen = false;
    _this.keyboardTriggered = false;
    _this.buttonRef = createRef();
    _this.portalRoot = getPortalRoot("popover-root");
    _this.randomId = randomString();
    _this.setIsOpen = function (isOpen, details) {
      var _a, _b;
      (_b = (_a = _this.props).onChange) == null ? void 0 : _b.call(_a, isOpen, details);
      _this.internalIsOpen = isOpen;
    };
    _this.handleButtonClick = function (event) {
      if (_this.props.onClickStopPropagation) {
        event == null ? void 0 : event.stopPropagation();
      }
      _this.setIsOpen(!_this.isOpen, {
        reason: "clicked-button"
      });
    };
    _this.handleButtonKeyDown = function (event) {
      if (event.key === KeyType.Enter) {
        _this.keyboardTriggered = true;
      }
    };
    _this.handleExited = function () {
      _this.keyboardTriggered = false;
    };
    return _this;
  }
  _createClass(Popover, [{
    key: "popoverId",
    get: function get() {
      return this.props.id || "popover-".concat(this.randomId);
    }
  }, {
    key: "isOpen",
    get: function get() {
      var _a;
      return (_a = this.props.isOpen) != null ? _a : this.internalIsOpen;
    }
  }, {
    key: "caretSize",
    get: function get() {
      return this.props.caret ? 14 : 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _button,
        _this2 = this;
      var _this$props = this.props,
        button = _this$props.button,
        children = _this$props.children,
        size = _this$props.size,
        className = _this$props.className,
        theme = _this$props.theme,
        offset = _this$props.offset,
        position = _this$props.position,
        recalculatePositionOnResize = _this$props.recalculatePositionOnResize,
        padding = _this$props.padding,
        outerMargin = _this$props.outerMargin;
      return /* @__PURE__ */React.createElement(React.Fragment, null, button((_button = {
        ref: this.buttonRef
      }, _defineProperty(_button, "aria-controls", this.popoverId), _defineProperty(_button, "aria-expanded", this.isOpen), _defineProperty(_button, "onClick", this.handleButtonClick), _defineProperty(_button, "onKeyDown", this.handleButtonKeyDown), _button)), /* @__PURE__ */React.createElement(Transition, {
        mountOnEnter: true,
        unmountOnExit: true,
        in: this.isOpen,
        timeout: AnimationDuration.Medium,
        onExited: this.handleExited,
        onEnter: forceReflow
      }, function (status) {
        return createPortal( /* @__PURE__ */React.createElement(Layer, null, function (_ref) {
          var zIndex = _ref.zIndex;
          return /* @__PURE__ */React.createElement(PopoverPanel, {
            className: className,
            id: _this2.popoverId,
            theme: theme,
            size: size,
            position: position,
            caretSize: _this2.caretSize,
            setIsOpen: _this2.setIsOpen,
            status: status,
            buttonRef: _this2.buttonRef,
            offset: offset,
            keyboardTriggered: _this2.keyboardTriggered,
            maxHeight: _this2.props.maxHeight,
            style: {
              zIndex: _this2.props.autoStack ? zIndex : void 0
            },
            recalculatePositionOnResize: recalculatePositionOnResize,
            alignment: _this2.props.alignment,
            padding: padding,
            outerMargin: outerMargin
          }, children);
        }), _this2.portalRoot);
      }));
    }
  }]);
  return Popover;
}(Component);
Popover.defaultProps = {
  theme: "light" /* Light */,
  size: "medium" /* Medium */,
  position: "bottom" /* Bottom */,
  offset: 4,
  padding: "medium",
  autoStack: true
};
__decorateClass([observable.ref], Popover.prototype, "internalIsOpen", 2);
__decorateClass([observable.ref], Popover.prototype, "keyboardTriggered", 2);
__decorateClass([computed], Popover.prototype, "popoverId", 1);
__decorateClass([computed], Popover.prototype, "isOpen", 1);
__decorateClass([computed], Popover.prototype, "caretSize", 1);
__decorateClass([action], Popover.prototype, "setIsOpen", 2);
__decorateClass([action], Popover.prototype, "handleButtonClick", 2);
__decorateClass([action], Popover.prototype, "handleButtonKeyDown", 2);
__decorateClass([action], Popover.prototype, "handleExited", 2);
Popover = __decorateClass([observer], Popover);
var PopoverPanel = /*#__PURE__*/function (_Component2) {
  _inherits(PopoverPanel, _Component2);
  var _super2 = _createSuper(PopoverPanel);
  function PopoverPanel() {
    var _this3;
    _classCallCheck(this, PopoverPanel);
    _this3 = _super2.apply(this, arguments);
    _this3.popoverRef = createRef();
    _this3.handleTargetRectChange = function (targetRect) {
      var _a;
      if (!targetRect || !shouldUpdatePosition(targetRect)) return;
      var _this3$props = _this3.props,
        caretSize = _this3$props.caretSize,
        position = _this3$props.position,
        offset = _this3$props.offset;
      var overlayRect = (_a = _this3.popoverRef.current) == null ? void 0 : _a.getBoundingClientRect();
      var newPopoverPosition = getOverlayPosition({
        position: position,
        targetRect: targetRect,
        overlayRect: overlayRect,
        offset: offset || 0 - caretSize + caretSize * Math.sqrt(2) / 2,
        caretSize: caretSize,
        outerMargin: _this3.props.outerMargin,
        alignment: _this3.props.alignment
      });
      _this3.popoverPosition = newPopoverPosition;
    };
    _this3.handleOuterClick = function (event) {
      var _a, _b;
      var target = event.target;
      if (target !== _this3.popoverRef.current && target !== _this3.props.buttonRef.current && !((_a = _this3.popoverRef.current) == null ? void 0 : _a.contains(target)) && !((_b = _this3.props.buttonRef.current) == null ? void 0 : _b.contains(target)) && !(event.target instanceof HTMLElement && event.target.closest(".nested-portal"))) {
        _this3.props.setIsOpen(false, {
          reason: "clicked-outside"
        });
      }
    };
    _this3.handleKeyDown = function (event) {
      if (event.key === KeyType.Escape) {
        _this3.props.setIsOpen(false, {
          reason: "pressed-escape"
        });
      }
    };
    _this3.onResize = function () {
      if (_this3.props.recalculatePositionOnResize && _this3.props.buttonRef.current) {
        _this3.handleTargetRectChange(_this3.props.buttonRef.current.getBoundingClientRect());
      }
    };
    return _this3;
  }
  _createClass(PopoverPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      var _a, _b;
      this.rectObserver = observeRect(this.props.buttonRef.current, this.handleTargetRectChange);
      (_a = this.rectObserver) == null ? void 0 : _a.observe();
      document.addEventListener("mousedown", this.handleOuterClick);
      document.addEventListener("keydown", this.handleKeyDown);
      if (this.props.buttonRef.current) {
        this.teardownScrollAway = scrollAwayObserver(this.props.buttonRef.current, {
          onScrollAway: function onScrollAway() {
            _this4.props.setIsOpen(false, {
              reason: "scrolled-away"
            });
          }
        });
      }
      if (this.props.keyboardTriggered) {
        (_b = this.popoverRef.current) == null ? void 0 : _b.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _a, _b, _c;
      (_a = this.rectObserver) == null ? void 0 : _a.unobserve();
      document.removeEventListener("mousedown", this.handleOuterClick);
      document.removeEventListener("keydown", this.handleKeyDown);
      (_b = this.teardownScrollAway) == null ? void 0 : _b.call(this);
      if (this.props.keyboardTriggered) {
        (_c = this.props.buttonRef.current) == null ? void 0 : _c.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _a;
      if (this.props.buttonRef.current && (prevProps.size !== this.props.size || prevProps.caretSize !== this.props.caretSize || prevProps.offset !== this.props.offset)) {
        this.handleTargetRectChange((_a = this.props.buttonRef.current) == null ? void 0 : _a.getBoundingClientRect());
      }
    }
  }, {
    key: "position",
    get: function get() {
      var _a;
      return ((_a = this.popoverPosition) == null ? void 0 : _a.modifier) || this.props.position;
    }
  }, {
    key: "render",
    value: function render() {
      var _a, _b, _c, _d;
      var _this$props2 = this.props,
        className = _this$props2.className,
        id = _this$props2.id,
        theme = _this$props2.theme,
        size = _this$props2.size,
        caretSize = _this$props2.caretSize,
        children = _this$props2.children,
        status = _this$props2.status,
        recalculatePositionOnResize = _this$props2.recalculatePositionOnResize,
        padding = _this$props2.padding;
      return /* @__PURE__ */React.createElement("div", {
        ref: this.popoverRef,
        className: classNames("popover", className),
        onClick: function onClick(event) {
          return event.stopPropagation();
        },
        onMouseUp: handleMouseUpByBlurring,
        tabIndex: -1,
        id: id,
        style: __spreadProps(__spreadValues({}, (_a = this.props.style) != null ? _a : {}), {
          transform: "translate3d(".concat(((_b = this.popoverPosition) == null ? void 0 : _b.overlay.left) || 0, "px, ").concat(((_c = this.popoverPosition) == null ? void 0 : _c.overlay.top) || 0, "px, 0)")
        })
      }, /* @__PURE__ */React.createElement(Panel, {
        theme: theme === "dark" /* Dark */ ? "dark" : "light",
        className: classNames("popover__panel", "popover__panel--".concat(theme), "popover__panel--".concat(status), "popover__panel--".concat(size), "popover__panel--".concat(this.position))
      }, !!caretSize && /* @__PURE__ */React.createElement("div", {
        className: classNames("popover__caret", "popover__caret--".concat(this.position), "popover__caret--".concat(theme)),
        style: __spreadProps(__spreadValues({}, (_d = this.popoverPosition) == null ? void 0 : _d.caret), {
          width: caretSize,
          height: caretSize
        })
      }), /* @__PURE__ */React.createElement("div", {
        className: "popover__panel-scroll",
        style: {
          maxHeight: this.props.maxHeight
        }
      }, /* @__PURE__ */React.createElement("div", {
        className: classNames("popover__panel-content", "popover__panel-content--padding-".concat(padding))
      }, children))), recalculatePositionOnResize && /* @__PURE__ */React.createElement(ReactResizeDetector, {
        onResize: this.onResize
      }));
    }
  }]);
  return PopoverPanel;
}(Component);
PopoverPanel.defaultProps = {
  outerMargin: 16
};
__decorateClass([observable.ref], PopoverPanel.prototype, "popoverPosition", 2);
__decorateClass([computed], PopoverPanel.prototype, "position", 1);
__decorateClass([action], PopoverPanel.prototype, "handleTargetRectChange", 2);
__decorateClass([action], PopoverPanel.prototype, "handleOuterClick", 2);
__decorateClass([action], PopoverPanel.prototype, "handleKeyDown", 2);
PopoverPanel = __decorateClass([observer], PopoverPanel);
export default Popover;